import React from 'react';
import { useNavigate } from 'react-router-dom';

const AuctionLotCard = ({ lot, auctionId }) => {
  const navigate = useNavigate();

  const handleCardClick = () => {
    navigate(`/auctions/${auctionId}/lots/${lot.lot_number}`);
  };

  return (
    <div 
      className="bg-white rounded-lg shadow-md p-4"
      onClick={handleCardClick}
    >
      <div className="flex justify-between items-start">
        <div>
          <p className="text-sm font-medium text-gray-900">Lot #{lot.lot_number}</p>
          <p className="text-sm text-gray-500">{lot.description}</p>
        </div>
        <div className="text-right">
          <p className="text-sm font-medium text-gray-900">{lot.winning_bid ? `$${lot.winning_bid}` : '-'}</p>
          <p className="text-sm text-gray-500">{lot.status}</p>
        </div>
      </div>
    </div>
  );
};

export default AuctionLotCard;
